module.exports = __webpack_public_path__ + "static/media/chevron-right-icon.4b8f449d.svg";